import { render, staticRenderFns } from "./BalanceCard.vue?vue&type=template&id=6e26d052&scoped=true&"
import script from "./BalanceCard.vue?vue&type=script&lang=js&"
export * from "./BalanceCard.vue?vue&type=script&lang=js&"
import style0 from "./BalanceCard.vue?vue&type=style&index=0&id=6e26d052&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e26d052",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
